import removeAccents from 'remove-accents';
import { BeaconUUID } from '../slices/beacons';
import { ClusterId } from '../slices/clusters';

type UserWithName = {
  fullname?: string;
  user_fullname?: string;
  email?: string;
  email_address?: string;
  user_email?: string;
};

type UserClusterRole = {
  cluster_id: ClusterId;
  certiphyto_number?: string;
  phonenumber?: string;
};

type UserWithClusterRoles = {
  cluster_roles?: UserClusterRole[];
  phonenumber?: string;
};

type UserWithBeacon = {
  current_beacon_uuid?: BeaconUUID;
};

export const userContains = (user: UserWithName, filter: string) => {
  const f = removeAccents(filter).toLowerCase();
  return removeAccents(getUserName(user)).toLowerCase().includes(f);
};

export const getUserPhytoNumber = (user: UserWithClusterRoles | undefined, clusterId: ClusterId) => {
  if (!user || !user.cluster_roles) {
    return null;
  }
  const cluster_role = user.cluster_roles.find(({ cluster_id }) => {
    return cluster_id === clusterId;
  });
  return cluster_role?.certiphyto_number;
};

export const getUserName = (user?: UserWithName) => {
  if (!user) return '';
  // worksites and device sessions carry the user flattened as `user_fullname` / `user_email`
  const name = (user.fullname ?? user.user_fullname ?? '').trim();
  return name || user.email || user.email_address || user.user_email || '';
};

export const sortUserByBeaconLinked = (a: UserWithBeacon, b: UserWithBeacon) =>
  a.current_beacon_uuid && !b.current_beacon_uuid ? -1 : b.current_beacon_uuid && !a.current_beacon_uuid ? 1 : 0;

export function sortByCertiphytoFirst(a: UserWithClusterRoles, b: UserWithClusterRoles, clusterId: ClusterId) {
  if (getUserPhytoNumber(a, clusterId) && !getUserPhytoNumber(b, clusterId)) return -1;
  if (!getUserPhytoNumber(a, clusterId) && getUserPhytoNumber(b, clusterId)) return 1;
  return 0;
}

export function getUserClusterPhoneNumber(user: UserWithClusterRoles | undefined, clusterId: ClusterId) {
  if (!user || !user.cluster_roles) {
    return null;
  }
  const cluster_role = user.cluster_roles.find(({ cluster_id }) => {
    return cluster_id === clusterId;
  });
  return cluster_role?.phonenumber;
}

export function getUserPhoneNumberToDisplay(user: UserWithClusterRoles | undefined, clusterId: ClusterId) {
  if (!user) {
    return null;
  }
  return getUserClusterPhoneNumber(user, clusterId) || user.phonenumber;
}
